import { useTitle }   from '@/Utilities/Hooks'
import HomeLayout     from '@/Layouts/HomeLayout'
import React, { useState, useEffect } from "react";

const Demo = ({}) => {
    useTitle('Book a demo')

    const [iframeHeight, setIframeHeight] = useState(window.innerWidth > 1020 ? '1585px' : '2075px');

    useEffect(() => {
        const handleResize = () => {
            const newHeight = window.innerWidth > 1020 ? '1585px' : '2075px';
            setIframeHeight(newHeight);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return <>
        <div className="bg-background pt-8 md:pt-16 pb-8">

            <iframe
                id="book-a-demo-iframe"
                title="Survey"
                src="https://outlook.office365.com/owa/calendar/DemoEmma@dille.se/bookings/s/L-w0cJaCL0iGEtXQYI-A2A2"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                style={{width: '100%', height: iframeHeight}}
            >
                Loading…
            </iframe>
        </div>
  </>
}

Demo.layout = page => <HomeLayout>{ page }</HomeLayout>

export default Demo
